import { t } from '@/i18n'
import type { CourierReport } from '@/types'

import { EmptySeparator, InfoItem, Label, Section, Separator, Tab, Total } from './components'

function courierInfo(
  report: CourierReport & {
    total: number
    courierName: string
  }
) {
  return [
    new Section(`${report.courierName}`),
    new InfoItem(t('couriers.from'), report.from, {
      valueType: 'date',
      style: 'normal 16px'
    }),
    new InfoItem(t('couriers.to'), new Date(), {
      valueType: 'date',
      style: 'normal 16px'
    })
  ]
}

function paymentMethods(
  report: CourierReport & {
    total: number
    courierName: string
  }
) {
  return [
    new Section(t('couriers.payment-methods')),
    ...Object.keys(report.payments).map(
      paymentMethod =>
        new InfoItem(paymentMethod, report.payments[paymentMethod], {
          valueType: 'currency',
          style: 'normal 16px'
        })
    )
  ]
}

function orders(
  report: CourierReport & {
    total: number
    courierName: string
  }
) {
  return [
    new Section(t('couriers.orders')),
    ...report.tabs
      .filter(tab => !tab.pending)
      .map(tab => new Tab(tab.code, tab.creationTime, tab.total)),
    new EmptySeparator(),
    new Label(t('couriers.pending-orders'), {
      style: 'bold 20px',
      lineHeight: 50
    }),
    ...report.tabs
      .filter(tab => tab.pending)
      .map(tab => new Tab(tab.code, tab.creationTime, tab.total))
  ]
}

function generateCourierReport(
  report: CourierReport & {
    total: number
    courierName: string
  }
) {
  return [
    new Label(t('couriers.title'), {
      style: 'bold 28px',
      lineHeight: 50
    }),
    ...courierInfo(report),
    ...paymentMethods(report),
    ...orders(report),
    new EmptySeparator(),
    new Separator(),
    new Total(report.total)
  ]
}

export default generateCourierReport
